import { useQueries, UseQueryResult } from 'react-query';
import { WALLETS_CONFIG } from '../config/wallets';
import { fetchWalletData } from '../services/crypto';
import { WalletData } from '../types/crypto';

export const useCryptoWallets = () => {
  const walletQueries = useQueries(
    WALLETS_CONFIG.map((wallet) => ({
      queryKey: ['wallet', wallet.id, wallet.address],
      queryFn: () => fetchWalletData(wallet),
      refetchInterval: 30000, // Auto refresh every 30 seconds
      refetchOnWindowFocus: false,
      retry: 2,
    }))
  ) as UseQueryResult<WalletData, Error>[];

  return {
    wallets: WALLETS_CONFIG.map((config, idx) => ({
      config,
      query: walletQueries[idx]
    }))
  };
};
